import { IAction } from 'legacy/lut/classes/models/onboarding/IAction'

import { onboardingActionApi, TSaveAssignedUser } from '../api/OnboardingActionApi'

class ActionService {
  public fetchActions = (requestId: string, inheritable?: number) => {
    return onboardingActionApi.getActions(+requestId, inheritable)
  }

  public updatePopupSettings(id: number, isShowOnceViewed: boolean) {
    return onboardingActionApi.updatePopupSettings(id, isShowOnceViewed)
  }

  public refreshPopupContent(actionUUID: string, requestId: number) {
    return onboardingActionApi.refreshPopupContent(actionUUID, requestId)
  }

  public reopenOne(
    actionUuid: string,
    requestId: number
  ): Promise<{ isReopened: boolean; item: IAction }> {
    return onboardingActionApi.reopenOne(actionUuid, requestId)
  }

  public updateAssignedUser(id: number, assignedUser: TSaveAssignedUser) {
    return onboardingActionApi.updateAssignedUser(id, assignedUser)
  }

  public updateExpirationDate(id: number, expirationDate: string) {
    return onboardingActionApi.updateExpirationDate(id, expirationDate)
  }

  public fetchWIPActionPopupContent(requestId: number) {
    return onboardingActionApi.fetchWIPActionPopupContent(requestId)
  }

  public getActionsLastHistory(actionIds: number[]) {
    return onboardingActionApi.getActionsLastHistory(actionIds)
  }

  public getExecutableTransitions(requestId: number) {
    return onboardingActionApi.getExecutableTransitions(requestId)
  }

  public getErrorsCount() {
    return onboardingActionApi.getErrorsCount()
  }

  public getActionLastErrorHistories(actionIds: number[]) {
    return onboardingActionApi.getActionLastErrorHistories(actionIds)
  }

  public updateExpirationTimer(id: number, hours: number) {
    return onboardingActionApi.updateExpirationTimer(id, hours)
  }

  public executeExpirationTimer(id: number) {
    return onboardingActionApi.executeExpirationTimer(id)
  }
}

export const actionService = new ActionService()
